import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  LEAD_RFIS_REFRESH: createSagaAction('LEAD_RFIS_REFRESH'),

  LEAD_RFI_CREATE: createSagaAction('LEAD_RFI_CREATE'),
  LEAD_RFI_UPDATE: createSagaAction('LEAD_RFI_UPDATE'),
  LEAD_RFI_DELETE: createSagaAction('LEAD_RFI_DELETE'),

  GET_LEAD_RFI_DATA: createSagaAction('GET_LEAD_RFI_DATA'),

  UPLOAD_LEAD_RFI_ATTACHMENT: createSagaAction('UPLOAD_LEAD_RFI_ATTACHMENT'),
  GET_LEAD_RFI_ATTACHMENTS: createSagaAction('GET_LEAD_RFI_ATTACHMENTS'),
  UPDATE_LEAD_RFI_ATTACHMENT_DESCRIPTION: createSagaAction(
    'UPDATE_LEAD_RFI_ATTACHMENT_DESCRIPTION'
  ),
  DELETE_LEAD_RFI_ATTACHMENT: createSagaAction('DELETE_LEAD_RFI_ATTACHMENT')
}

// Action Creators
export const actions = {
  leadRFIsRefresh: ({ leadId }) => ({
    type: constants.LEAD_RFIS_REFRESH.ACTION,
    leadId
  }),

  createLeadRFI: ({ leadId, content, rfiItems, userId }) => ({
    type: constants.LEAD_RFI_CREATE.ACTION,
    leadId,
    content,
    rfiItems,
    userId
  }),

  updateLeadRFI: ({ leadId, rfiId, content, rfiItems, userId }) => ({
    type: constants.LEAD_RFI_UPDATE.ACTION,
    leadId,
    rfiId,
    content,
    rfiItems,
    userId
  }),

  deleteLeadRFI: ({ rfiId, leadId }) => ({
    type: constants.LEAD_RFI_DELETE.ACTION,
    leadId,
    rfiId
  }),

  getLeadRfiData: ({ rfiId, leadId }) => ({
    type: constants.GET_LEAD_RFI_DATA.ACTION,
    leadId,
    rfiId
  }),

  // Attachment actions
  uploadLeadRfiAttachment: ({ formData, leadRfiId }) => ({
    type: constants.UPLOAD_LEAD_RFI_ATTACHMENT.ACTION,
    formData,
    leadRfiId
  }),

  getLeadRfiAttachments: ({ leadRfiId }) => ({
    type: constants.GET_LEAD_RFI_ATTACHMENTS.ACTION,
    leadRfiId
  }),

  updateLeadRfiAttachmentDescription: ({ attachmentId, currentId, description, userId }) => ({
    type: constants.UPDATE_LEAD_RFI_ATTACHMENT_DESCRIPTION.ACTION,
    attachmentId,
    currentId,
    description,
    userId
  }),

  deleteLeadRfiAttachment: ({ attachmentId, currentId }) => ({
    type: constants.DELETE_LEAD_RFI_ATTACHMENT.ACTION,
    attachmentId,
    currentId
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.LEAD_RFIS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.LEAD_RFIS_REFRESH.SUCCESS:
      return {
        ...state,
        leadRFIs: action.payload
      }
    case constants.LEAD_RFIS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.LEAD_RFI_CREATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_RFI_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.LEAD_RFI_DELETE.SUCCESS:
      return {
        ...state
      }
    case constants.GET_LEAD_RFI_DATA.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_LEAD_RFI_DATA.SUCCESS:
      return {
        ...state,
        leadRfiItems: action.payload
      }

    // attachments
    case constants.UPLOAD_LEAD_RFI_ATTACHMENT.ACTION:
      return { ...state, error: null, uploadingAttachment: true }
    case constants.UPLOAD_LEAD_RFI_ATTACHMENT.SUCCESS:
      return {
        ...state,
        uploadingAttachment: false
      }
    case constants.GET_LEAD_RFI_ATTACHMENTS.ACTION:
      return { ...state, error: null, loadingAttachments: true }
    case constants.GET_LEAD_RFI_ATTACHMENTS.SUCCESS:
      return {
        ...state,
        leadRfiAttachments: action.payload,
        loadingAttachments: false
      }
    case constants.UPDATE_LEAD_RFI_ATTACHMENT_DESCRIPTION.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_LEAD_RFI_ATTACHMENT.ACTION:
      return { ...state, error: null, deletingAttachment: true }
    case constants.DELETE_LEAD_RFI_ATTACHMENT.SUCCESS:
      return {
        ...state,
        deletingAttachment: false
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/leadFunctions/leadRFIActions.js